//angular imports
import {
    ChangeDetectionStrategy,
    Component, 
    WritableSignal, 
    signal,
} from '@angular/core';

//local imports
import { PresenterType } from '@shared/components';
import { ProjectAlreadyExistsMessage } from './project-already-exists.message';

@PresenterType(
{
    model: ProjectAlreadyExistsMessage
})
@Component({
    selector: 'project-already-exists-message-template',
    templateUrl: './project-already-exists-message-template.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ProjectAlreadyExistsMessageTemplateComponent
{
    public data: WritableSignal<ProjectAlreadyExistsMessage>;
    
    constructor() {
        this.data = signal<ProjectAlreadyExistsMessage>(null);
    }
}